/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function CreditCardJuicyIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="credit-card-juicy"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.5 6.5C2.5 5.395 3.395 4.5 4.5 4.5L19.5 4.5C20.605 4.5 21.5 5.395 21.5 6.5L21.5 17.5C21.5 18.605 20.605 19.5 19.5 19.5L4.5 19.5C3.395 19.5 2.5 18.605 2.5 17.5L2.5 6.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M2.5 8L21.5 8" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M6 12L9.5 12" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
    </svg>
  )
}
